import { gql } from '@apollo/client';

const GET_FOOTER = gql`
  query Header {
    footer {
      navigationBox {
        links {
          id
          label
          url
          isExternal
        }
        title
      }
      contactInfoBox {
        infoDetailsList {
          id
          label
          icon {
            url
            name
          }
        }
        title
      }
      socialLinkBox {
        title
        iconLinkList {
          icon {
            url
          }
          isExternal
          url
        }
      }
      downloadLinks {
        id
        url
        linkImage {
          width
          name
          url
        }
      }
      footerBottom {
        privacyLinks {
          id
          label
          url
          isExternal
        }
        copyRights
      }
      privacyPolicyContent
      termsConditionContent
    }
  }
`;

export default GET_FOOTER;
